import {Permissions} from 'auth/PermissionConstants';
import {User} from 'constants/UserConstants';

export const FEATURE_LIBRARY_BASE_URL = '/1/api/feature-libraries/';

export enum MatchType {
  NUCLEOTIDE = 'nucleotide',
  PROTEIN = 'protein',
}

export enum ImportType {
  APE = 'ape',
  CSV = 'csv',
}

export interface ServerFeature {
  id: number;
  name: string;
  feature_type: string;
  bases: string;
  color: string;
  library_id: number;
  match_type: 'nucleotide' | 'protein';
}

export interface Feature extends ServerFeature {
  // Client state.
  selected: boolean;
}

export interface FeatureLibrary {
  count: number;
  created_at: string;
  description: string;
  features: Array<Feature>;
  id: number;
  api_identifier: string;
  name: string;
  owner: User;
  ownerInfo: {
    memberDataPolicyId: string | null;
    type: string;
  };
  owner_handle: string;
  owner_url: string;
  owner_url_identifier: string;
  permissions: Permissions;
}
